module.exports = __webpack_public_path__ + "media/images/brands/brand-pu-337f6469652f3399e345a282bcf35b49.jpg";